import {
  buildCommonInsuranceContractParameters,
  ensureCorrectCommissionFormat,
} from '../buildCommonInsuranceContractParameters'

export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  const options = buildCommonInsuranceContractParameters({
    type,
    contractId,
    contactId,
    addressId,
    contractData,
    characteristicsData,
    action,
  })

  if (contractData.fees?.length > 0) {
    options.append('fees', ensureCorrectCommissionFormat(contractData.fees))
  }
  if (contactPreferences.createEkomiInteraction) {
    options.append('create_ekomi_interaction', '1')
  }
  if (contractData.businessCard) {
    options.append('business_card', contractData.businessCard === 1 ? '1' : '0')
  }

  return options
}
